export const INVOICE_STATUS_OPTIONS = [
  { value: "", label: "All statuses" },
  { value: "draft", label: "Draft" },
  { value: "open", label: "Open" },
  { value: "paid", label: "Paid" },
  { value: "uncollectible", label: "Uncollectible" },
  { value: "void", label: "Void" },
] as const;

/** Values for multi-select (excludes “all”). */
export const INVOICE_STATUS_MULTI_OPTIONS = INVOICE_STATUS_OPTIONS.filter(
  (o) => o.value !== "",
);

export function invoiceStatusLabel(value: string): string {
  const opt = INVOICE_STATUS_OPTIONS.find((o) => o.value === value);
  return opt?.label ?? (value || "—");
}

export type InvoiceStatusVariant = "paid" | "open" | "void" | "neutral";

export function invoiceStatusVariant(status: string): InvoiceStatusVariant {
  const s = status?.toLowerCase();
  if (s === "paid") return "paid";
  if (s === "open") return "open";
  if (s === "void" || s === "uncollectible") return "void";
  return "neutral";
}
